<div class="dd-list-container {{disabled?'a-disabled':''}}" [ngClass]="cssClass" [ngStyle]="{ width: width }" #container>
  <div #ddListBox class="dd-list-box" (click)="onClick($event)">
    <span *ngIf="arrowIconToLeft" class="dd-list-icon fa fa-angle-down"
      [ngClass]="{ 'dd-list-icon_open': isOpen }"></span>
    <span class="dd-list-label" [ngClass]="{ 'dd-list-left': textAlign === 'left' }" *ngIf="!displayTemplate">
      <div>
        {{ displayName }}
      </div>
    </span>
    <span class="dd-list-label" [ngClass]="{ 'dd-list-left': textAlign === 'left' }" *ngIf="displayTemplate">
      <span *ngTemplateOutlet="displayTemplate; context: displayTemplateContext"></span>
    </span>
    <span *ngIf="!arrowIconToLeft" class="dd-list-icon fa fa-angle-down"
      [ngClass]="{ 'dd-list-icon_open': isOpen }"></span>
  </div>
  <div class="dd-list-popup-container" [@showAndHidePopup] [ngClass]="{'dd-list-popup-align-left':popupAlign==='left'}" [style.width.px]="getPopupWidth()" *ngIf="isOpen">
    <div *ngIf="showSearchBox" class="dd-list-search-box-wrapper">
      <ad-text class="dd-list-search-box" placeholder="search" iconClass="fa-search" iconPosition="right" [(ngModel)]="filterContent"
        (onKeyUp)="inputSearch($event)"></ad-text>
    </div>
    <div class="dd-list-popup-bottom" [ngClass]="{'dd-list-no-search':!showSearchBox,'dd-list-scrollable-no-virtual':!enableVirtualScroll}" [style.height.px]="enableVirtualScroll?popupHeight:'auto'">
      <cdk-virtual-scroll-viewport *ngIf="enableVirtualScroll" [itemSize]="itemHeight" [minBufferPx]="popupHeight"
        [maxBufferPx]="popupHeight" class="dd-list-vs-wrapper">
        <ul class="dd-list-popup-wrapper">

          <li class="dd-list-option dd-list-select-all" [ngClass]="{ 'dd-list-option_active': selectAllStatus !== 0 }"
            *ngIf="multiple && showSelectAll && dataSourceAfterFiltered.length > 1" (click)="selectAllClick($event)">
            <div *ngIf="multiple" class="dd-list-multi-item-wrapper">
              <div class="dd-list-item-left">
                <span class="dd-list-check-icon" [ngClass]="selectAllClass"></span>
              </div>
              <div class="dd-list-item-right">
                <span class="dd-list-popup-label">{{ selectAllText }}</span>
              </div>
            </div>
          </li>
          <li class="dd-list-option" *cdkVirtualFor="let item of dataSourceAfterFiltered;trackBy:trackByFunFactory()"
            (click)="itemClick(item, $event)" (touchstart)="itemClick(item, $event)" [ngClass]="{
        'dd-list-option_active':
          (!multiple && item[valueField] === value) ||
          (multiple && item.selected)
      }">
            <div *ngIf="multiple" class="dd-list-multi-item-wrapper">
              <div class="dd-list-item-left">
                <span class="dd-list-check-icon" [ngClass]="
              item.selected
                ? 'dd-list-check ' + checkedIconClass
                : 'dd-list-uncheck ' + unCheckedIconClass
            "></span>
              </div>
              <div class="dd-list-item-right">
                <span class="dd-list-popup-label" *ngIf="!itemTextTemplate">{{
            item[textField]
          }}</span>
                <div *ngIf="itemTextTemplate">
                  <span *ngTemplateOutlet="itemTextTemplate; context: { item: item }"></span>
                </div>
              </div>
            </div>

            <span *ngIf="!multiple && !itemTextTemplate" class="dd-list-popup-label">{{ item[textField] }}</span>
            <div *ngIf="!multiple && itemTextTemplate">
              <span *ngTemplateOutlet="itemTextTemplate; context: { item: item }"></span>
            </div>
          </li>
        </ul>
      </cdk-virtual-scroll-viewport>

      <ul *ngIf="!enableVirtualScroll"  [style.max-height.px]="maxHeight" class="dd-list-popup-wrapper"
          [ngClass]="{'dd-list-popup-align-left':popupAlign==='left'}">

          <li class="dd-list-option dd-list-select-all" [ngClass]="{ 'dd-list-option_active': selectAllStatus !== 0 }"
            *ngIf="multiple && showSelectAll && dataSourceAfterFiltered.length > 1" (click)="selectAllClick($event)">
            <div *ngIf="multiple" class="dd-list-multi-item-wrapper">
              <div class="dd-list-item-left">
                <span class="dd-list-check-icon" [ngClass]="selectAllClass"></span>
              </div>
              <div class="dd-list-item-right">
                <span class="dd-list-popup-label">{{ selectAllText }}</span>
              </div>
            </div>
          </li>
          <li class="dd-list-option" *ngFor="let item of dataSourceAfterFiltered;trackBy:trackByFunFactory()"
            (click)="itemClick(item, $event)" (touchstart)="itemClick(item, $event)" [ngClass]="{
        'dd-list-option_active':
          (!multiple && item[valueField] === value) ||
          (multiple && item.selected)
      }">
            <div *ngIf="multiple" class="dd-list-multi-item-wrapper">
              <div class="dd-list-item-left">
                <span class="dd-list-check-icon" [ngClass]="
              item.selected
                ? 'dd-list-check ' + checkedIconClass
                : 'dd-list-uncheck ' + unCheckedIconClass
            "></span>
              </div>
              <div class="dd-list-item-right">
                <span class="dd-list-popup-label" *ngIf="!itemTextTemplate">{{
            item[textField]
          }}</span>
                <div *ngIf="itemTextTemplate">
                  <span *ngTemplateOutlet="itemTextTemplate; context: { item: item }"></span>
                </div>
              </div>
            </div>

            <span *ngIf="!multiple && !itemTextTemplate" class="dd-list-popup-label">{{ item[textField] }}</span>
            <div *ngIf="!multiple && itemTextTemplate">
              <span *ngTemplateOutlet="itemTextTemplate; context: { item: item }"></span>
            </div>
          </li>
        </ul>
    </div>
  </div>
</div>